export interface UserPlan {
  id: string;
  plan: UserPlanType;
  trialEndDate?: string | null;
}

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  profilePictureUrl: string;
  timeZone: string | null;
  suspendedAt?: string | null;
  disqualifiedAt?: string | null;
  userPlan?: UserPlan | null;
  effectivePlan?: UserPlanType | null;
}

export enum UserPlanType {
  NO_CC = 'no_cc',
  FREE = 'free',
  LITE = 'lite',
  INFINITY = 'infinity',
  ENTERPRISE = 'enterprise',
  LEGACY = 'legacy',
}

export const PLAN_DISPLAY_NAMES: Record<UserPlanType, string> = {
  [UserPlanType.NO_CC]: 'Free',
  [UserPlanType.FREE]: 'Free',
  [UserPlanType.LITE]: 'Lite',
  [UserPlanType.INFINITY]: 'Infinity',
  [UserPlanType.ENTERPRISE]: 'Enterprise',
  [UserPlanType.LEGACY]: 'Legacy',
};
